import { render, staticRenderFns } from "./PatientSelfburden.vue?vue&type=template&id=05dfabb9&"
import script from "./PatientSelfburden.vue?vue&type=script&lang=ts&"
export * from "./PatientSelfburden.vue?vue&type=script&lang=ts&"
import style0 from "./PatientSelfburden.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports